const mainTheme = {
  color: {
    primary: '#B6252F',
    secondary: '#262626',
    grey: '#5C6364',
    dark: '#262626',
    light: '#FFFFFF',
  },

  font: {
    family: {
      primary: 'Helvetica Neue',
      secondary: 'Helvetica Neue',
    },

    size: {
      tiny: '10px',
      small: '14px',
      medium: '16px',
      big: '18px',
      large: '24px',
      huge: '30px',
      mega: '40px',
      giga: '60px',
    },

    weight: {
      light: 300,
      regular: 500,
      bold: 700,
      extraBold: 800,
    },
  },
}

export default mainTheme
